import React , {Component}  from 'react'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import 'bootstrap/dist/css/bootstrap-reboot.css';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all';

import Dashboard from './Dashboard/Dashboard'

// 傳入內部的 Context
import AppContext from "../AppContext";

export default class WebRouter extends Component
{
    constructor(props, context)
    {
        super(props, context);

        this.state = {
            isInited: false, // 畫面遮罩，等一切判斷跑完，再解除
        };
    }

    componentDidMount()
    {
        console.log("componentDidMount");

        this.setState({isInited:true });
    }

    render()
    {
        // 如果不是讀取中
        if (this.state.isInited === false) {return null;}

        return (
           <Dashboard/>
        )

    }
}


